// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"394f40eb","271":"e29652d9","392":"789efc4c","629":"0b1e51bc","671":"1ef993d6","702":"7a937b16","746":"ca966d78","787":"b6801e5f","836":"a465003d"}[chunkId] + ".chunk.js";
};